<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.66699 3.33334L13.3337 8.00001L8.66699 12.6667M2.66699 8.00001H13.3337H2.66699Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
